import type { TFunction } from "i18next";
import { appCopyIdentifiers } from "./appCopyIdentifiers.generated";

/** A leaf key that is present in the source-language translation catalog. */
export type AppCopyIdentifier = (typeof appCopyIdentifiers)[number];

const identifier = <Key extends AppCopyIdentifier>(key: Key): Key => key;

/**
 * Typed app-owned copy can be introduced one flow at a time while legacy
 * i18next call sites continue using `t` directly.
 */
export const appCopy = {
  sharedGroceryList: {
    loading: identifier("sharedGroceryList.loading"),
    empty: identifier("sharedGroceryList.empty_list"),
    notFound: identifier("sharedGroceryList.not_found"),
    mutationFailed: identifier("sharedGroceryList.mutation_failed"),
    error: {
      title: identifier("sharedGroceryList.error_title"),
      body: identifier("sharedGroceryList.error_loading"),
      accessUnavailableTitle: identifier(
        "sharedGroceryList.access_unavailable_title",
      ),
      accessUnavailableBody: identifier("sharedGroceryList.access_unavailable"),
    },
  },
} as const;

export const translateAppCopy = (
  translate: TFunction,
  copyIdentifier: AppCopyIdentifier,
): string => translate(copyIdentifier) as string;
